const translation = {
    profile: {
        cta: {
            consents: "Управление соглашениями"
        }
    }
};

export default translation;
